import { ChakraFlex, ModalV2, FireflyButton, Text } from '@equip.health/ui';

const NeverStartedConfirmModal = ({ isOpen, onCancel, onConfirm }) => (
  <ModalV2
    footerContent={
      <ChakraFlex justifyContent="space-between" width="100%">
        <FireflyButton
          id="never-started-cancel"
          onClick={onCancel}
          variant="secondary"
        >
          Cancel
        </FireflyButton>
        <FireflyButton
          id="never-started-confirm"
          onClick={onConfirm}
          variant="primary"
        >
          Confirm
        </FireflyButton>
      </ChakraFlex>
    }
    isOpen={isOpen}
    onClose={onCancel}
    title="Confirm Never Started"
  >
    <Text id="never-started-warning" variant="body">
      Setting this episode to 'Never Started' will delete all future programs
      except the first. Are you sure you want to continue?"
    </Text>
  </ModalV2>
);

export default NeverStartedConfirmModal;
